package dev.lingvo.site.components.studio.editor

import androidx.compose.runtime.Composable
import dev.lingvo.shared.screenshots.text.FitResult
import dev.lingvo.site.ds.LBadge
import dev.lingvo.site.ds.LBadgeVariant
import dev.lingvo.site.i18n.t
import dev.lingvo.site.i18n.tf

/** Fit is explained with size and floor so warning and refusal never rely on colour alone. */
@Composable
internal fun FitMeter(caption: CaptionSnapshot) {
    val fit = caption.fit
    val floor = caption.layer.fit.floorSize
    when {
        fit == null -> LBadge(t("studio.editor.fit_meter.checking_caption_fit", "Checking caption fit"))
        fit is FitResult.Refused -> LBadge(tf("studio.fit_refused", "Doesn't fit at {floor} px. Shorten it or widen the box.",
            "floor" to floor), variant = LBadgeVariant.DANGER, wrap = true)
        fit.layout.size <= floor * 1.1 -> LBadge(tf("studio.fit_floor", "Shrunk to {size} px · floor {floor}",
            "size" to fit.layout.size, "floor" to floor), variant = LBadgeVariant.WARNING, wrap = true)
        else -> LBadge(tf("studio.fit_ok", "{size} of {maximum} px", "size" to fit.layout.size,
            "maximum" to caption.layer.fit.maxSize), variant = LBadgeVariant.SUCCESS)
    }
}
